import React, { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import ReactSlick from 'react-slick'
import cn from 'classnames'
import debounce from 'lodash/debounce'
import reduce from 'lodash/reduce'

import ButtonArrow from 'app/components/ButtonArrow'
import { getDimensions } from 'helpers/multibrowserHelper'

import './styles.scss'

const baseClass = 'base-slider'
const breakpoints = {
  huge: 1260,
  large: 1040,
  medium: 778,
  small: 410,
}
const defaultSettings = {
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  easing: 'linear',
  prevArrow: <ButtonArrow left buttonClass={`${baseClass}__prev`} />,
  nextArrow: <ButtonArrow right buttonClass={`${baseClass}__next`} />,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerMode: false,
  responsive: [
    {
      breakpoint: breakpoints.huge,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
      },
    },
    {
      breakpoint: breakpoints.large,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
      },
    },
    {
      breakpoint: breakpoints.medium,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
      },
    },
    {
      breakpoint: breakpoints.small,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
      },
    },
  ],
}

class Slider extends Component {
  static defaultProps = {
    items: [],
    entityName: 'Slide',
    defaultSettings: defaultSettings,
    settings: {},
  }

  static propTypes = {
    items: PropTypes.array.isRequired,
    card: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object,
    settings: PropTypes.shape({
      dots: PropTypes.bool,
      infinite: PropTypes.bool,
      speed: PropTypes.number,
      slidesToShow: PropTypes.number,
      slidesToScroll: PropTypes.number,
      nextArrow: PropTypes.node,
      prevArrow: PropTypes.node,
    }),
    cardProps: PropTypes.objectOf(PropTypes.any),
    entityName: PropTypes.string,
    catchError: PropTypes.func,
  }

  state = {
    currentNumber: 1,
    count: 0,
    hideNext: false,
    hidePrev: false,
    disableSlider: false,
    settings: { ...defaultSettings, ...this.props.settings },
    hidden: true,
  }

  componentDidMount() {
    this.setCount(this.props)
    this.resize = debounce(this.checkSlideability, 500)
    window.addEventListener('resize', this.resize)
    setTimeout(() => window.dispatchEvent(new Event('resize')), 0)
    setTimeout(
      () =>
        this.setState({
          hidden: false,
        }),
      450
    )
  }

  componentWillUnmount() {
    if (this.resize) {
      window.removeEventListener('resize', this.resize)
    }
  }

  setCount = props => this.setState({ count: props.items.length }, this.checkSlideability)

  changeSlide = (oldIndex, newIndex) => {
    if (newIndex < 0) {
      setTimeout(() => this.slider.slickGoTo(0), 2000)
    }
    this.setState({ currentNumber: newIndex + 1 })
  }

  updateControls = (currentSlideIndex = 0) => {
    try {
      const slidesPossible = Math.ceil(this.state.count / this.state.applicableBreakpoint.settings.slidesToShow)
      const currentSlide = Math.ceil((currentSlideIndex + 1) / this.state.applicableBreakpoint.settings.slidesToShow)
      this.setState({
        hideNext: currentSlide === slidesPossible,
        hidePrev: currentSlide === 1,
      })
    } catch (error) {
      this.props.catchError({ error })
      this.setState({
        hideNext: false,
        hidePrev: false,
      })
    }
  }

  checkSlideability = () => {
    if (!this.state.settings) return
    const { width } = getDimensions()
    const defaultBreakpoint = {
      breakpoint: 9999,
      settings: {
        slidesToShow: this.state.settings.slidesToShow,
        slidesToScroll: this.state.settings.slidesToScroll,
      },
    }
    const applicableBreakpoint = reduce(
      this.state.settings.responsive,
      (previous, current) => {
        if (current.breakpoint > width) return current
        return previous
      },
      defaultBreakpoint
    )
    this.setState(
      {
        applicableBreakpoint: applicableBreakpoint,
        disableSlider: this.state.count <= applicableBreakpoint.settings.slidesToShow,
      },
      this.updateControls
    )
  }

  render() {
    const { card, items, cardProps, entityName } = this.props
    const { currentNumber, count, hidePrev, hideNext, disableSlider } = this.state
    return (
      <div
        className={cn(baseClass, {
          'hide-prev': hidePrev,
          'hide-next': hideNext,
          'less-slides': disableSlider,
        })}
      >
        <ReactSlick
          ref={node => (this.slider = node)}
          {...this.state.settings}
          className={`${baseClass}__slider ${this.state.hidden ? 'hidden' : ''}`}
          dotsClass={`${baseClass}__dots`}
          init={this.checkSlideability}
          beforeChange={this.changeSlide}
          afterChange={this.updateControls}
        >
          {items.map(item => {
            return (
              <div key={item.id} className={`${baseClass}__item-wrapper`}>
                {createElement(card, { ...item, ...cardProps })}
              </div>
            )
          })}
        </ReactSlick>
        <div className={`${baseClass}__page-number`}>
          <span>{`${entityName} `}</span>
          <span>{currentNumber}</span>
          <span>{' of '}</span>
          <span>{count}</span>
        </div>
      </div>
    )
  }
}

export default Slider
